// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.empty-content {\r\n  background: #f7f7f7;\r\n  border-radius: 7px;\r\n  margin: 10px 0 0 0;\r\n  padding: 15px 0 6px 26px;\n}\r\n", ""]);
// Exports
module.exports = exports;
